import React from "react";
import { Dialog, DialogTitle, Slide } from "@mui/material";
import { Close } from "@mui/icons-material";
import { withStyles } from "tss-react/mui";
import Button from "../../../components/CustomButtons/Button";
import GridContainer from "../../../components/Grid/GridContainer";
import GridItem from "../../../components/Grid/GridItem";
import TranslationWrapper from "../../../components/TranslationWrapper/TranslationWrapper.tsx";
import notificationsStyle from "../../../assets/jss/material-dashboard-pro-react/views/notificationsStyle.tsx";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction={"down"} ref={ref} {...props} />;
});

class ConfirmRefund extends React.Component {
  emailInput = React.createRef();

  state = {
    saving: false,
    bestelling: {},
    loading: true,
    canSendEmail: false,
    refunding: false,
  };

  handleRefund = () => {
    this.props.ok();
  };

  /**
   * Get financial format
   */
  getNumberformat(value, currency = "EUR") {
    return new Intl.NumberFormat("nl-NL", {
      style: "currency",
      currency: currency.toUpperCase(),
      currencyDisplay: "symbol",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(value);
  }

  render() {
    const { classes } = this.props;
    /*   var paymentObject =
          this.state.bestelling.paymentDetails && this.state.bestelling.paymentDetails.statusSuccess !== undefined
            ? this.state.bestelling.paymentDetails.statusSuccess.report
            : null;
        let refundableAmount =
          this.state.bestelling !== undefined && this.state.bestelling && this.state.bestelling.metadata !== undefined
            ? (this.state.bestelling.metadata.orderValue * 100 - this.state.bestelling.refunded) / 100
            : 0; */
    return (
      <Dialog
        TransitionComponent={Transition}
        aria-describedby={"notice-modal-slide-description"}
        aria-labelledby={"notice-modal-slide-title"}
        fullWidth={false}
        keepMounted
        maxWidth={"lg"}
        onClose={this.props.toggle}
        open={this.props.open}
        scroll={"paper"}
      >
        <DialogTitle className={classes.modalHeader} disableTypography id={"notice-modal-slide-title"}>
          <Button
            aria-label={"Close"}
            className={classes.modalCloseButton}
            color={"transparent"}
            justIcon
            key={"close"}
            onClick={this.props.toggle}
          >
            <Close className={classes.modalClose} />
          </Button>
          <h4>
            <TranslationWrapper
              tDefault={"Are you sure you want to refund this order?"}
              tKey={"bestellingen.modal.paymentrefund.confirm.title"}
            />
          </h4>
        </DialogTitle>
        <GridContainer style={{ margin: "0px", width: "100%" }}>
          <GridItem align={"center"} md={6}>
            <Button color={"danger"} disabled={this.state.refunding} onClick={this.props.ok} style={{ width: "100%" }}>
              <TranslationWrapper tDefault={"Yes, refund"} tKey={"bestellingen.modal.refundConfirm.text.yes"} />
            </Button>
          </GridItem>
          <GridItem align={"center"} md={6}>
            <Button
              color={"default"}
              disabled={this.state.refunding}
              onClick={this.props.cancel}
              style={{ width: "100%" }}
            >
              <TranslationWrapper tDefault={"No"} tKey={"bestellingen.modal.paymentdetail.text.refund.no"} />
            </Button>
          </GridItem>
        </GridContainer>
      </Dialog>
    );
  }
}

export default withStyles(ConfirmRefund, notificationsStyle);
